module.exports = __webpack_public_path__ + "static/img/slide_4_fr.b1068ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_4_fr.svg
// module id = Q3Kz
// module chunks = 0